<template>
  <div class="menu-wrapper">

    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
            <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
            <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
            <el-badge :value="$store.state.app.count" :max="99" class="item" v-if="item.meta&&item.meta.title == '购物车'">
            </el-badge>
        </el-menu-item>
      </router-link>

      <!--template v-else v-for="child in item.children" >
        <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

        <router-link :to="item.path+'/'+child.path" :key="child.name">
          <el-menu-item :index="item.path+'/'+child.path">
            <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
            <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
          </el-menu-item>
        </router-link>
      </template-->


      <router-link v-else :to="item.redirect" :key="item.children[0].name">
        <el-menu-item :key="item.name">
          <template slot="title">
            <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
            <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
            <!-- <el-badge :value="$store.state.app.count" :max="99" class="item" v-if="item.meta&&item.meta.title == '购物车'">
            </el-badge> -->
          </template>
        </el-menu-item>
      </router-link>

    </template>
  </div>
</template>

<script>
	import {fetchList} from '@/api/shoppingCart'
	import {PointscartList} from '@/api/integralShop'
export default {
  name: 'SidebarItem',
  data(){
	return{

	}
  },
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
	async getQuantity(){
		const res = await this.$store.dispatch('changeCount');
	}
  },
  created() {
  	this.getQuantity();
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .el-badge{
    position: absolute;
    left: 105px;
    top: 5px;
  }
  .el-badge /deep/ .el-badge__content{ //第一种写法
      color: #252733;
      background-color: white;
	  line-height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue